'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/9/18.
                    */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';

var ExperienceShopCommissionComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ExperienceShopCommissionComponent, _Component);

  function ExperienceShopCommissionComponent() {
    (0, _classCallCheck3.default)(this, ExperienceShopCommissionComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopCommissionComponent).apply(this, arguments));
  }

  (0, _createClass3.default)(ExperienceShopCommissionComponent, [{
    key: 'itemClick',
    value: function itemClick(filterStr) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        onItemClick(filterStr);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var input = this.refs.searchInput;
      var onSearch = this.props.onSearch;

      if (onSearch) {
        // console.log(input);
        onSearch(input.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ExperienceShopCommissionComponent.scss');
      var _props = this.props;
      var experienceShopCommissionData = _props.experienceShopCommissionData;
      var experienceShopCommissionSummarize = _props.experienceShopCommissionSummarize;
      var currentPage = _props.currentPage;
      var orderItem = _props.orderItem;

      var commissionsShow = experienceShopCommissionData.map(function (commission, index) {
        return _react2.default.createElement(
          'tr',
          { key: commission.id + index, style: { background: index % 2 === 0 ? '#f9f8f8' : '' } },
          _react2.default.createElement(
            'td',
            { className: styles.pt },
            currentPage * 20 + index + 1
          ),
          _react2.default.createElement(
            'td',
            { className: styles.pt },
            commission.time
          ),
          _react2.default.createElement(
            'td',
            { className: styles.pt },
            commission.name
          ),
          _react2.default.createElement(
            'td',
            { className: styles.pt },
            commission.product
          ),
          _react2.default.createElement(
            'td',
            { className: styles.pt },
            commission.shop
          ),
          _react2.default.createElement(
            'td',
            { className: styles.pt },
            commission.buymoney
          ),
          _react2.default.createElement(
            'td',
            { className: styles.pt },
            commission.commissions
          )
        );
      });
      var commissionsTotalShow = _react2.default.createElement(
        'div',
        { style: { height: 40, width: '100%' } },
        _react2.default.createElement(
          'div',
          { className: styles.sqtxt1 },
          '截止日期：',
          experienceShopCommissionSummarize[0].deadlines
        ),
        _react2.default.createElement(
          'div',
          { className: styles.sqtxt2, style: { marginRight: 8 } },
          '购买总额：¥',
          _react2.default.createElement(
            'span',
            { style: { marginRight: 25 } },
            experienceShopCommissionSummarize[0].totalBuyMoney
          ),
          '佣金提成额：¥',
          _react2.default.createElement(
            'span',
            null,
            experienceShopCommissionSummarize[0].totalCommissions
          ),
          '可提现金额：¥',
          _react2.default.createElement(
            'span',
            null,
            experienceShopCommissionSummarize[0].withdrawCommissions
          )
        )
      );
      return _react2.default.createElement(
        'div',
        null,
        commissionsTotalShow,
        _react2.default.createElement(
          'ul',
          { className: styles.jsdd },
          _react2.default.createElement(
            'li',
            { className: orderItem === '' ? styles.border : '', onClick: function onClick() {
                return _this2.itemClick('');
              } },
            '全部'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'buymoney' ? styles.border : '', onClick: function onClick() {
                return _this2.itemClick('buymoney');
              } },
            '购买金额'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'commissions' ? styles.border : '', onClick: function onClick() {
                return _this2.itemClick('commissions');
              } },
            '提成金额'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.jsallshou },
          _react2.default.createElement('input', { ref: 'searchInput', type: 'text' }),
          _react2.default.createElement(
            'div',
            { onClick: this.search.bind(this) },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/shc.png', alt: '', className: 'img' })
          )
        ),
        _react2.default.createElement(
          'table',
          { className: styles.allTable },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { width: '6%' }),
            _react2.default.createElement('col', { width: '14%' }),
            _react2.default.createElement('col', { width: '12%' }),
            _react2.default.createElement('col', { width: '22%' }),
            _react2.default.createElement('col', { width: '22%' }),
            _react2.default.createElement('col', { width: '12%' }),
            _react2.default.createElement('col', { width: '12%' })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '序号'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买时间'
              ),
              _react2.default.createElement(
                'th',
                null,
                '姓名'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买艺品'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买店铺'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买金额'
              ),
              _react2.default.createElement(
                'th',
                null,
                '提成金额'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            commissionsShow
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ExperienceShopCommissionComponent;
}(_react.Component), _class.propTypes = {
  experienceShopCommissionData: _react.PropTypes.array.isRequired,
  experienceShopCommissionSummarize: _react.PropTypes.array.isRequired,
  onSearch: _react.PropTypes.func,
  onItemClick: _react.PropTypes.func,
  currentPage: _react.PropTypes.number,
  orderItem: _react.PropTypes.string
}, _temp);
exports.default = ExperienceShopCommissionComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ExperienceShopCommissionComponent/ExperienceShopCommissionComponent.js
 ** module id = 1327
 ** module chunks = 0
 **/